/**
 * TanStack Query hooks for `sub-network-creation`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	subNetworkCreationQueryKeys,
	type CreateSubNetworkCreationBody,
	type ListSubNetworkCreationResponse,
	type SubNetworkCreationRow,
} from "./api";

export function useSubNetworkCreationList(): UseQueryResult<ListSubNetworkCreationResponse, Error> {
	return useQuery({
		queryKey: subNetworkCreationQueryKeys.list(),
		queryFn: list,
	});
}

export function useSubNetworkCreationCreate(): UseMutationResult<SubNetworkCreationRow, Error, CreateSubNetworkCreationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: subNetworkCreationQueryKeys.all });
		},
	});
}

export function useSubNetworkCreationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: subNetworkCreationQueryKeys.all });
		},
	});
}
